import { FormProvider } from 'react-hook-form'

export const FormHookProvider = ({ methods, method, onSubmit, className, children, noForm = false }) => {
  return (
    <FormProvider {...methods}>
      <div className={className}>
        {noForm ? (
          children
        ) : (
          <form onSubmit={methods.handleSubmit(onSubmit)} method={method}>
            {children}
          </form>
        )}
      </div>
    </FormProvider>
  )
}
